(function () {
  'use strict';
  if (customElements.get('dio-button-videos')) return;

  function initialize(root) {
    var panels = Array.from(root.querySelectorAll('[data-button-video-panel]'));
    var tabs = Array.from(root.querySelectorAll('[data-button-video-tab]'));
    var motionButton = root.querySelector('[data-dio-demo-motion]');
    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var widthQuery = window.matchMedia('(max-width: 749px)');
    var restartOnSwitch = root.dataset.restartVideoOnSwitch === 'true';
    var autoAdvanceOnEnd = root.dataset.autoAdvanceOnEnd === 'true';
    var motionPaused = root.dataset.dioMotionPaused === undefined ? motionQuery.matches : root.dataset.dioMotionPaused === 'true';
    if (motionQuery.matches && root.dataset.dioLastMotionPreference !== 'true') motionPaused = true;
    root.dataset.dioLastMotionPreference = String(motionQuery.matches);
    var endedVideo = null;
    var endedHandler = null;
    var removers = [];
    var timers = new Set();
    var closed = false;
    var resizeTimeout;
    var viewportRoot = root.querySelector('.button-video') || root;
    var nearViewport = !window.IntersectionObserver;
    var inViewport = !window.IntersectionObserver;
    var prepareObserver;
    var playbackObserver;

    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      removers.push(function () { target.removeEventListener(type, handler, options); });
    }

    function later(handler, delay) {
      var timer = window.setTimeout(function () {
        timers.delete(timer);
        if (!closed) handler();
      }, delay);
      timers.add(timer);
      return timer;
    }

    function updateMotionButton() {
      motionButton.textContent = motionPaused ? 'Play demo' : 'Pause demo';
      motionButton.setAttribute('aria-label', motionPaused ? 'Play demo videos' : 'Pause demo videos');
      motionButton.title = motionButton.getAttribute('aria-label');
      motionButton.dataset.dioPaused = String(motionPaused);
      root.dataset.dioMotionPaused = String(motionPaused);
    }

    // Buffer the selected clip near the viewport without advancing its timeline.
    // Other current-width clips are primed after selected playback begins.
    // Opposite encodings remain inert until needed after a breakpoint change.
    function prepareResponsiveVideos(panel, explicit) {
      if ((!nearViewport && !inViewport && !explicit) || document.hidden || !viewportRoot.getClientRects().length) return;
      var version = widthQuery.matches ? 'mobile' : 'desktop';
      root.querySelectorAll('[data-dio-video-version="' + version + '"]').forEach(function (wrapper) {
        if (panel && !panel.contains(wrapper)) return;
        var existing = wrapper.querySelector('video');
        if (existing) {
          if (panel && !motionPaused) existing.preload = 'auto';
          return;
        }
        var template = wrapper.querySelector('template[data-dio-video-template]');
        if (template) {
          var content = root.ownerDocument.importNode(template.content, true);
          var video = content.querySelector('video');
          if (video) {
            video.muted = video.hasAttribute('muted');
            video.playsInline = video.hasAttribute('playsinline');
            video.autoplay = false;
            video.preload = panel && !motionPaused ? 'auto' : 'metadata';
          }
          wrapper.appendChild(content);
          if (video) video.load();
        }
      });
    }

    function getVisibleVideos(panel) {
      if (!panel) return [];
      return Array.from(panel.querySelectorAll('video')).filter(function (video) {
        return video.getClientRects().length;
      });
    }

    function activePanel() {
      return panels.find(function (panel) { return panel.style.display === 'block'; });
    }

    function clearAutoAdvanceBinding() {
      if (endedVideo && endedHandler) endedVideo.removeEventListener('ended', endedHandler);
      endedVideo = null;
      endedHandler = null;
    }

    function pauseAll() {
      root.querySelectorAll('video').forEach(function (video) { video.autoplay = false; video.pause(); });
    }

    function pauseHidden() {
      root.querySelectorAll('video').forEach(function (video) {
        if (!inViewport || document.hidden || !video.getClientRects().length) { video.autoplay = false; video.pause(); }
      });
    }

    function syncPlayback() {
      if (closed) return;
      if (!inViewport || document.hidden || motionPaused || !viewportRoot.getClientRects().length) {
        pauseAll();
        clearAutoAdvanceBinding();
        return;
      }
      prepareResponsiveVideos(activePanel());
      playPanelVideos(activePanel());
      bindAutoAdvance(activePanel());
    }

    function playPanelVideos(panel) {
      if (closed || motionPaused || !inViewport || document.hidden || !root.isConnected) return;
      getVisibleVideos(panel).forEach(function (video) {
        video.autoplay = true;
        if (!video.paused) return;
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () {});
      });
    }

    function bindAutoAdvance(panel) {
      clearAutoAdvanceBinding();
      if (closed || !autoAdvanceOnEnd || !panel || motionPaused || motionQuery.matches || !inViewport || document.hidden) return;
      var videos = getVisibleVideos(panel);
      if (!videos.length) return;
      endedVideo = videos[0];
      endedHandler = function () {
        if (closed || motionPaused || !inViewport || document.hidden) return;
        clearAutoAdvanceBinding();
        var index = tabs.findIndex(function (tab) { return tab.classList.contains('active'); });
        if (index < 0) return;
        var next = tabs[(index + 1) % tabs.length];
        showPanel(next.getAttribute('data-video-target'), next, restartOnSwitch ? 'switch' : false);
      };
      endedVideo.addEventListener('ended', endedHandler);
    }

    function pauseAndResetPanelVideos(panel) {
      panel.querySelectorAll('video').forEach(function (video) {
        video.autoplay = false;
        video.pause();
        video.currentTime = 0;
      });
    }

    function revealPanel(panelId, tab, panel, explicit) {
      if (closed || !root.isConnected) return;
      panel.style.display = 'block';
      panel.setAttribute('aria-hidden', 'false');
      prepareResponsiveVideos(panel, explicit);
      panels.forEach(function (other) {
        if (other.id === panelId) return;
        other.style.display = 'none';
        other.setAttribute('aria-hidden', 'true');
        other.querySelectorAll('video').forEach(function (video) { video.autoplay = false; video.pause(); });
        if (restartOnSwitch) pauseAndResetPanelVideos(other);
      });
      tabs.forEach(function (other) {
        other.classList.toggle('active', other === tab);
        other.setAttribute('aria-pressed', String(other === tab));
      });
      playPanelVideos(panel);
      bindAutoAdvance(panel);
    }

    function showPanel(panelId, tab, restartMode, explicit) {
      var panel = panels.find(function (item) { return item.id === panelId; });
      if (!panel || closed) return;
      if (restartOnSwitch && restartMode === 'same') {
        getVisibleVideos(panel).forEach(function (video) { video.currentTime = 0; });
        revealPanel(panelId, tab, panel, explicit);
      } else if (restartOnSwitch && restartMode === 'switch') {
        clearAutoAdvanceBinding();
        pauseAndResetPanelVideos(panel);
        revealPanel(panelId, tab, panel, explicit);
      } else {
        revealPanel(panelId, tab, panel, explicit);
      }
    }

    root.isMotionPaused = function () { return motionPaused; };
    listen(root, 'canplay', function (event) {
      if (event.target.paused && getVisibleVideos(activePanel()).includes(event.target)) {
        playPanelVideos(activePanel());
      }
    }, true);
    listen(root, 'playing', function (event) {
      if (getVisibleVideos(activePanel()).includes(event.target)) prepareResponsiveVideos();
    }, true);
    updateMotionButton();

    listen(motionButton, 'click', function () {
      var isPlaying = getVisibleVideos(activePanel()).some(function (video) { return !video.paused && !video.ended; });
      motionPaused = !motionPaused && isPlaying;
      if (motionPaused) { pauseAll(); clearAutoAdvanceBinding(); }
      else { prepareResponsiveVideos(activePanel(), true); syncPlayback(); }
      updateMotionButton();
    });

    listen(motionQuery, 'change', function (event) {
      root.dataset.dioLastMotionPreference = String(event.matches);
      if (!event.matches) return;
      motionPaused = true;
      pauseAll();
      clearAutoAdvanceBinding();
      updateMotionButton();
    });

    tabs.forEach(function (tab) {
      listen(tab, 'click', function () {
        var target = tab.getAttribute('data-video-target');
        if (!target) return;
        motionPaused = false;
        updateMotionButton();
        showPanel(target, tab, restartOnSwitch ? (tab.classList.contains('active') ? 'same' : 'switch') : false, true);
      });
    });

    var initialTab = tabs.find(function (tab) { return tab.classList.contains('active'); }) || tabs[0];
    if (initialTab) showPanel(initialTab.getAttribute('data-video-target'), initialTab, false);

    if (root.dataset.nested === 'true') {
      root.resetToFirstStep = function (shouldPlay) {
        clearAutoAdvanceBinding();
        panels.forEach(function (panel) { pauseAndResetPanelVideos(panel); panel.style.display = 'none'; panel.setAttribute('aria-hidden', 'true'); });
        tabs.forEach(function (tab, index) { tab.classList.toggle('active', index === 0); tab.setAttribute('aria-pressed', String(index === 0)); });
        if (!panels[0]) return;
        panels[0].style.display = 'block';
        panels[0].setAttribute('aria-hidden', 'false');
        if (shouldPlay) { prepareResponsiveVideos(panels[0], true); syncPlayback(); }
      };
    }

    listen(widthQuery, 'change', function () {
      pauseAll();
      prepareResponsiveVideos(activePanel());
      syncPlayback();
    });

    // Newly hydrated nested media must also pause if its parent tab closes.
    // Capture handles future video nodes without taking ownership of tabs.
    listen(root, 'play', pauseHidden, true);
    listen(document, 'visibilitychange', function () {
      if (!document.hidden) prepareResponsiveVideos(activePanel());
      syncPlayback();
    });
    if (window.IntersectionObserver) {
      prepareObserver = new IntersectionObserver(function (entries) {
        nearViewport = entries[0].isIntersecting;
        if (nearViewport) prepareResponsiveVideos(activePanel());
      }, {rootMargin: '1000px 0px'});
      prepareObserver.observe(viewportRoot);
      playbackObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // Start after meaningful entry; pause only after completely leaving.
        if (!entry.isIntersecting || entry.intersectionRatio === 0) inViewport = false;
        else if (entry.intersectionRatio >= 0.2) inViewport = true;
        syncPlayback();
      }, {threshold: [0, 0.2]});
      playbackObserver.observe(viewportRoot);
    }
    var visibility = new MutationObserver(pauseHidden);
    visibility.observe(root.closest('.collapse-tab-eecol') || root, {
      subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden']
    });

    if (autoAdvanceOnEnd) listen(window, 'resize', function () {
      window.clearTimeout(resizeTimeout);
      timers.delete(resizeTimeout);
      resizeTimeout = later(function () { bindAutoAdvance(activePanel()); }, 150);
    });

    return function cleanup() {
      closed = true;
      clearAutoAdvanceBinding();
      visibility.disconnect();
      if (prepareObserver) prepareObserver.disconnect();
      if (playbackObserver) playbackObserver.disconnect();
      removers.forEach(function (remove) { remove(); });
      timers.forEach(function (timer) { window.clearTimeout(timer); });
      pauseAll();
      delete root.isMotionPaused;
      delete root.resetToFirstStep;
    };
  }

  class DioButtonVideos extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      if (!this.querySelector('[data-button-video-ready]')) {
        if (!this.childrenObserver) {
          this.childrenObserver = new MutationObserver(() => this.connectedCallback());
          this.childrenObserver.observe(this, {childList: true, subtree: true});
        }
        return;
      }
      if (this.childrenObserver) { this.childrenObserver.disconnect(); this.childrenObserver = null; }
      this.cleanup = initialize(this);
    }

    disconnectedCallback() {
      if (this.childrenObserver) { this.childrenObserver.disconnect(); this.childrenObserver = null; }
      if (this.cleanup) { this.cleanup(); this.cleanup = null; }
    }
  }

  customElements.define('dio-button-videos', DioButtonVideos);
})();
